<template>
  <div v-if="active" class="generation-countdown">
    <div>{{ estimateText }}</div>
    <div>{{ remainingText }}</div>
  </div>
</template>
<script>
const estimates = { tianyancha: [5, 10], businessAi: [2, 5], competitorAi: [3, 8], visitAi: [1, 3], openAi: [1, 3], backendAi: [1, 3], cardAi: [1, 3] }
const starts = {}
const format = seconds => Math.floor(seconds / 60).toString().padStart(2, '0') + ':' + (seconds % 60).toString().padStart(2, '0')
export default {
  props: { active: Boolean, taskKey: String, kind: String, startedAt: [String, Number] },
  data() { return { now: Date.now(), start: 0, timer: null } },
  computed: {
    estimateText() { const range = estimates[this.kind]; return range ? '预计 ' + range[0] + '～' + range[1] + ' 分钟' : '正在查询工商资料' },
    remainingText() {
      const elapsed = Math.max(0, Math.floor((this.now - this.start) / 1000))
      const range = estimates[this.kind]
      if (!range) return '已等待 ' + format(elapsed)
      const remaining = range[1] * 60 - elapsed
      return remaining > 0 ? '预计剩余约 ' + format(remaining) + '，可关闭窗口稍后查看' : '处理时间超出预估，仍在生成中，已等待 ' + format(elapsed)
    }
  },
  watch: { active: 'sync', taskKey: 'sync', startedAt: 'sync' },
  mounted() { this.sync() },
  beforeDestroy() { clearInterval(this.timer) },
  methods: {
    sync() {
      clearInterval(this.timer)
      if (!this.taskKey) return
      const key = 'generation-start:' + this.taskKey
      if (!this.active) {
        delete starts[key]
        try { sessionStorage.removeItem(key) } catch (_) { /* Storage is optional. */ }
        return
      }
      let saved = starts[key]
      try { saved = saved || Number(sessionStorage.getItem(key)) } catch (_) { /* Use memory. */ }
      const explicit = typeof this.startedAt === 'number' ? this.startedAt : Date.parse((this.startedAt || '').replace(' ', 'T'))
      this.now = Date.now()
      this.start = explicit > 0 && explicit <= this.now ? explicit : saved > 0 && saved <= this.now ? saved : this.now
      starts[key] = this.start
      try { sessionStorage.setItem(key, String(this.start)) } catch (_) { /* Use memory. */ }
      this.timer = setInterval(() => { this.now = Date.now() }, 1000)
    }
  }
}
</script>
<style scoped>
.generation-countdown { font-size: 12px; line-height: 1.7; font-weight: normal; color: #409eff; margin-top: 8px; white-space: normal; }
</style>



// WEBPACK FOOTER //
// src/components/GenerationCountdown.vue